import { ChakraProvider } from '@chakra-ui/react';
import Router from '@/router';
import { system } from '@/theme';
import { Toaster } from '@/components/ui/toaster';

function App() {
  return (
    <div
      id="app"
      style={{
        width: '100%'
      }}
    >
      <ChakraProvider value={system}>
        <Router />
        <Toaster />
      </ChakraProvider>
    </div>
  );
}

export default App;
